import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import Swal from "sweetalert2";
import { login } from "../../redux/slice/auth/authSlice";
import { useSignInMutation } from "../../api/authApi";

const Login = ({ isSignIn, toggleForm }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [signIn, { isLoading }] = useSignInMutation();
  const [formValues, setFormValues] = useState({
    email: "",
    password: "",
  });
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
    setErrors({
      ...errors,
      [name]: "",
    });
  };

  const validate = () => {
    const newErrors = {};
    if (!formValues.email) newErrors.email = "Email is required";
    if (!formValues.password) newErrors.password = "Password is required";
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = validate();
    if (Object.keys(newErrors).length === 0) {
      setIsSubmitting(true);
      try {
        const data = await signIn(formValues).unwrap();
        console.log("From Data", data);
        if (data.statusCode == "200" && data.status) {
          Swal.fire({
            icon: "success",
            title: data.message,
            confirmButtonColor: "#1EB733",
            width: 350,
            showConfirmButton: false,
            timer: 600,
          });
          dispatch(login());
          localStorage.setItem("isLoggedIn", "true");
          localStorage.setItem(
            "userToken",
            JSON.stringify(data.responseObject.token)
          );
          localStorage.setItem(
            "userData",
            JSON.stringify(data.responseObject.userData)
          );
          navigate("/");
          setFormValues({
            email: "",
            password: "",
          });
        }
      } catch (error) {
        console.error("Error:", error);
        Swal.fire({
          icon: "error",
          title: error?.data?.message || "Failed to signin",
          confirmButtonColor: "#d33",
          width: 350,
        });
      } finally {
        setIsSubmitting(false);
      }
    } else {
      setErrors(newErrors);
    }
  };

  return (
    <>
      <div className="flex flex-col justify-center w-[88%]">
        <form className="flex flex-col gap-2" onSubmit={handleSubmit}>
          <div>
            <label
              htmlFor="email"
              className="flex text-sm font-medium leading-6 text-gray-900"
            >
              Email
            </label>
            <div>
              <input
                id="email"
                name="email"
                type="email"
                value={formValues.email}
                onChange={handleChange}
                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
              />
              {errors.email && (
                <div className="text-red-600 text-[10px]">{errors.email}</div>
              )}
            </div>
          </div>

          <div>
            <div className="flex items-center justify-between">
              <label
                htmlFor="password"
                className="block text-sm font-medium leading-6 text-gray-900"
              >
                Password
              </label>
            </div>
            <div className="relative">
              <input
                id="password"
                name="password"
                type={showPassword ? "text" : "password"}
                value={formValues.password}
                onChange={handleChange}
                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
              />
              <span
                className="absolute inset-y-0 right-0 flex items-center pr-3 cursor-pointer"
                onClick={() => setShowPassword((prev) => !prev)}
              >
                <i
                  className={`fa ${showPassword ? "fa-eye" : "fa-eye-slash"}`}
                  aria-hidden="true"
                ></i>
              </span>
            </div>
            {errors.password && (
              <div className="text-red-600 text-[10px]">{errors.password}</div>
            )}
          </div>

          <div className="mt-3">
            <button
              type="submit"
              className="flex w-full justify-center rounded-md bg-[#1EB733] px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-[#1EB733] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
              {isSubmitting ? "Signing in..." : "Sign in"}
            </button>
          </div>
        </form>

      </div>
        <div
          className=" text-gray-900 text-lg cursor-pointer hover:underline decoration-gray-600 text-center mt-3"
          onClick={toggleForm}
        >
          {isSignIn
            ? "Don't have an account? Sign Up"
            : "Already have an account? Sign In"}
        </div>
    </>
  );
};

export default Login;
